<template>
    <div class="paopaotui-sheet sheet" @click.stop="onClose">
        <div class="main" @click.stop>
            <div class="buttons">
                <div @click.stop="openAlbum">開啟相簿</div>
                <div @click.stop="openCamera">開啟相機</div>
            </div>
            <div class="cancel button" @click.stop="onClose">
                取消
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'OpenPhotoBottom',
        methods: {
            openCamera() {
                this.$emit('openCamera');
            },
            openAlbum() {
                this.$emit('openAlbum');
            },
            onClose() {
                this.$emit('onClose');
            }
        },
    };
</script>

<style lang="scss" scoped>
    .sheet {
        background-color: rgba(0,0,0,0.4);
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 10;
    }

    .main {
        border-radius: 10px 10px 0 0;
        padding: 25px 15px;
        position: absolute;
        width: 100%;
        box-sizing: border-box;
        bottom: 0;
        left: 0;
        transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
        max-height: 90vh;

        .buttons {
            border-radius: 14px;
            background-color: rgba(248,248,248,0.82);
            color: #007AFF;
            font-size: 20px;
            text-align: center;
            margin-bottom: 10px;
            cursor: pointer;
            user-select: none;

            div {
                padding: 15px;
                &:nth-child(even) {
                    border-top: solid 1px #000000;
                }
            }
        }

        .button {
            border-radius: 14px;
            background-color: #FFFFFF;
            color: #4A4A4A;
            font-size: 20px;
            font-weight: 600;
            text-align: center;
            padding: 15px;
            cursor: pointer;
            user-select: none;
        }
    }
</style>
